import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody | any;
    errors?: Array<string>;
}
export interface GeneralResponseBody {
    length: Boolean;
    data: Array<any>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;

    map(param: (survey: any) => any): any;
}

export const fetchSurveyType = createAction<fetchSurveyTypeAction>(
    ActionTypes.FETCH_SURVEY_TYPE,
);
export const fetchSurveyTypeSuccess =
    createAction<fetchSurveyTypeSuccessAction>(
        ActionTypes.FETCH_SURVEY_TYPE_SUCCESS,
    );
export const fetchSurveyTypeFailed = createAction<fetchSurveyTypeFailedAction>(
    ActionTypes.FETCH_SURVEY_TYPE_FAILED,
);

export const postSurveyAnswers = createAction<postSurveyAnswersAction>(
    ActionTypes.POST_SURVEY_ANSWERS,
);
export const postSurveyAnswersSuccess =
    createAction<postSurveyAnswersSuccessAction>(
        ActionTypes.POST_SURVEY_ANSWERS_SUCCESS,
    );
export const postSurveyAnswersFailed =
    createAction<postSurveyAnswersFailedAction>(
        ActionTypes.POST_SURVEY_ANSWERS_FAILED,
    );

export interface fetchSurveyTypeAction {
    type?: typeof ActionTypes.FETCH_SURVEY_TYPE;
    claimApplicationId: string;
}

export interface fetchSurveyTypeSuccessAction {
    type: typeof ActionTypes.FETCH_SURVEY_TYPE_SUCCESS;
    body: GeneralResponse;
}

export interface fetchSurveyTypeFailedAction {
    type: typeof ActionTypes.FETCH_SURVEY_TYPE_FAILED;
    body: GeneralResponse;
}

export interface postSurveyAnswersAction {
    type?: typeof ActionTypes.POST_SURVEY_ANSWERS;
}

export interface postSurveyAnswersSuccessAction {
    type: typeof ActionTypes.POST_SURVEY_ANSWERS_SUCCESS;
    body: GeneralResponse;
}

export interface postSurveyAnswersFailedAction {
    type: typeof ActionTypes.POST_SURVEY_ANSWERS_FAILED;
    body: GeneralResponse;
}
